import { IAppState } from '@state/types';

export const getUserConfig = (state: IAppState): any | undefined => state.userConfig.userConfig;

export const getUserConfigResponse = (state: IAppState): any | undefined => state.userConfig.response;